import { ReactNode } from "react";

export function Tabs({
	active,
	items,
	onClick,
}: {
	active?: string | null,
	onClick?: (key: string) => void,
	items: {
		label: string | ReactNode,
		key: string,
		disabled?: boolean,
	}[],
}) {

	if (items.length === 0) {
		return null;
	}

    return (
		<div className="discover-tabs">
			{items.map((item, index) => (
				<span
					key={`tab-${index}`}
					className={`discover-tabs__item ${item.key === active ? 'is-active' : ''} ${item.disabled ? 'is-disabled' : ''}`}
					onClick={() => onClick && !item.disabled ? onClick(item.key) : undefined}
				>
					{item.label}
				</span>
			))}
		</div>
)
}
